import React from 'react';

import { useStyles } from '../../Home/Intro/styles/introCardStyles';

export const PieLarge = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svgIcon}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
    >
      <path
        opacity='1'
        fill='#fff'
        d='M0 272C0 404.6 107.5 512 240 512c121.4 0 221.7-90.1 237.7-207c.1-.7 .1-1.4 .1-2c0-8.3-6.9-15-15.5-15L224 288V49.6c0-8.6-6.7-15.5-15-15.5c-.7 0-1.4 0-2 .1C90.1 50.3 0 150.7 0 272z'
      />
      <path
        fill='#D10066'
        className={classes.pieLarge}
        d='M272 240H495.4c9 0 16.6-7 16.6-16C512 100.3 411.7 0 288 0c-9 0-16 7.6-16 16.6V240z'
      />
    </svg>
  );
};
